import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing a jerry can icon
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <JerryCanIcon width={12} />
 */
const JerryCanIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M17.92,22h12V34h-12V22ZM40,10V40a4,4,0,0,1-4,4H12a4,4,0,0,1-4-4V16L18,6H36A4,
            4,0,0,1,40,10ZM19.91,10a2,2,0,0,0,2,2h12a2,2,0,0,0,2-2h0a2,2,0,0,0-2-2h-12a2,2,
            0,0,0-2,2h0Zm12,24.63V21.43l3.71-3.71a1,1,0,1,0-1.41-1.41L30.52,20H17.31l-3.69-3.69a1,
            1,0,1,0-1.41,1.41l3.71,3.71V34.61l-3.71,3.71a1,1,0,1,0,1.41,1.41L17.35,36H30.48l3.73,
            3.73a1,1,0,0,0,1.41-1.41Zm-22.5-28L6.58,9.41a2,2,0,0,0,2.83,2.83l2.83-2.83A2,2,0,1,
            0,9.41,6.58Z`}
        />
    </SvgIcon>
)

JerryCanIcon.defaultProps = defaultProps

export { JerryCanIcon }
